import React, { Component } from 'react';
import {
  Link
} from 'react-router-dom';
import './maindefinitions.css';
import './basicforms.css';


class HomePage extends Component {
//  constructor(props) {
//    super(props);

//    this.handleChange = this.handleChange.bind(this);
//    this.handleSubmit = this.handleSubmit.bind(this);
//  }



  render() {

    return (

		<div >
				<div className='homeContainer'>
					<img className='homepicture' alt="Home" src="https://s3.amazonaws.com/beango.io/images/201606_fazenda_143b.jpg" />
					<div className="centered2">
						<p className='headline'> café de verdade, direto da fazenda</p>
						<p className='headline3'> Nossos melhores lotes, com torra fresquinha, para você consumir na sua casa </p>
                        <div className="getStartedForm">
                            <Link to="/offeringspage">
                                <input type="button" value="Encomende aqui" />
                            </Link>
                        </div>

                    </div>
                    <div className="infoboxHome" >
                        <div className="textsnarrow">
                            <p className="blocktitle">PROJETO ANDORIAR</p>
                        <p> Nosso site está operando em fase de teste. Por enquanto, estamos disponibilizando café apenas para famílias do Colégio Sidarta, contribuindo para arrecadação de recursos para o projeto Andoriar.	</p>                      
                        <p> Se você não é do Sidarta, mas gostaria de comprar o café, por favor, entre em contato com hello@terraalta.coffee</p>
                        </div>
                       
                    </div>
				</div>


				<div className="textsnarrow">
				<div className="row">
						<div className="col-01 whatwedocontainer">
						<h1> </h1>

						</div>
						<div className="col-30 textsnarrow whatwedocontainer">
							<h2> Nossos melhores lotes </h2>
                        <p>	Na Fazenda Terra Alta, nós produzimos cafés especiais e exportamos para alguns dos melhores torrefadores dos Estados Unidos e Europa.
                            Para que uma parte desse café também ficasse aqui no Brasil, nós passamos a oferecer o café torrado. Para mais informações sobre a fazenda, visite
                            <a href="https://www.tacoffee.com.br/" target="_blank" className="linkInText"> www.tacoffee.com.br </a>
                        </p>
                        						
	  					</div>

						<div className="col-01 whatwedocontainer">
                        <h1> <i className="material-icons">add  </i> </h1>
						</div>
						<div className="col-30 textsnarrow whatwedocontainer">
                        	<h2> Torra fresquinha </h2>
                        <p>	Para que você tenha café sempre fresquinho e para evitar desperdício, nós torramos pequenas quantidades por encomenda.
                            O ideal é consumir o café em até 1 mês após a data da torra, ou antes, caso você prefira receber o café já moído. 
                            Passado esse período, o café não fica impróprio para o consumo, mas perde suas características sensoriais.            
                        </p>
	  					</div>
						<div className="col-01 whatwedocontainer">
                        <h1> <i className="material-icons">add  </i>  </h1>
						</div>
						<div className="col-30 textsnarrow whatwedocontainer">
								<h2> Contribuindo para um mundo melhor </h2>
								<p> Parte da receita da venda do café torrado será convertida para projetos sócio-ambientais. Nesse primeiro momento, nós estamos operando em fase de teste, contribuindo com o projeto Andoriar dos alunos do Colégio Sidarta.
								
								</p>
						</div>

				</div>
	  			</div>


	  			<div className="row">
					<div className="col-50">
						<div className="row whatwedocontainer2">
							<p className="blocktitle">MAS O QUE É CAFÉ ESPECIAL?</p>
                        <p className="headline2"> Os cafés especiais são cafés doces, COM acidez balanceada, aromas e sabores agradáveis e SEM os defeitos encontrados no café comercial, como amargor e adstringência.  </p>
						</div>
					</div>
					<div className="col-50 whatwedocontainer3">
						<div className="col-50 textsnarrow ">
							<p>
							O café que estamos acostumados a comprar no supermercado é, em geral, uma mistura de café arábica com robusta, uma espécie similar ao arábica, de produção mais barata e com amargor acentuado. 
                            Mesmo quando da espécie arábica, o café utilizado é de mais baixa qualidade: proveniente de varrição (café que cai no chão durante a colheita) ou infectados por fungos, por exemplo. Esses defeitos causam sabores desagradáveis no café.
                            Para disfarçar esses sabores desagradáveis, os fabricantes fazem uma torra muito escura (torram muito o café), que faz predominar o sabor de queimado. É por isso que a maioria das pessoas coloca açucar no café.
                            </p>
                            <p>
                            Os cafés especiais são cafés arábica que são produzidos de forma cuidadosa, eliminando defeitos e usando técnicas que geram aromas e sabores agradáveis
                            Por exemplo, como no vinho, hoje muitos lotes de café especial passam por fermentações controladas que aumentam a acidez, mantém a douçura e liberam aromas e sabores diferentes, como de frutas.
                            </p>

                            
						</div>
	  					<div className="col-50 textsnarrow ">
							<p>
							A torra no café especial é mais leve, pois é usada para salientar as características sensoriais do café e não esconder defeitos. 
                            Os torrefadores escolhem o perfil de torra de acordo com as qualidades do grão e com o uso. Por exemplo, uma torra media fica melhor com leite, enquanto uma torra leve se encaixa melhor para filtro.
                            </p>
                            <p>
                            Outra preocupação do café especial é produzir o café visando segurança alimentar e responsabilidade sócio-ambiental. 
                            Existem uma série de técnicas e programas que implementamos na fazenda para, por exemplo, reduzir o consumo de água, preservar áreas de reserva ambiental, usar defensivos de forma segura e apenas quando necessário, 
                            acompanhar passo a passo na produção, separando lotes de alta e baixa qualidade.
                            </p>
							
						</div>
					</div>

	  			</div>

	  			<div className='homeContainer margintopconatiner'>
					<img className='contactpicture' alt="Contact" src="https://s3.amazonaws.com/beango.io/images/201707_fta+gaviao.jpg" />
					<div className="contactcontainer">
						<div className="row">
							<div className="col-40">
                             
                            <img className='contactTextPicture' src="https://s3.amazonaws.com/beango.io/images/contatoPic.png" />
                            
							</div>
                        <div className="col-60 textsnarrow centertextalign">
                                <p className='pagetitle2'> Mande sua mensagem para:</p>
                                <p> hello@terraalta.coffee </p>
							</div>

						</div>

					</div>

				</div>


		</div>
		)
	}
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/HomePage.js